module.exports = __webpack_public_path__ + "media/virtual_show/vShowLogoDark-9172161f.png";